import { useLocation } from 'react-router-dom';
import { FormPageLayout } from '../layouts';

/**
 * Subscribe page - the full ActiveCampaign subscriber sign-up form (form 21).
 *
 * Reached from the footer subscribe card, which passes the address the visitor
 * already typed in router state so the email field arrives pre-filled and only
 * name, company and the reCAPTCHA are left to complete. Landing here directly
 * simply renders the empty form.
 *
 * No `formHeading` is passed: the ActiveCampaign export carries its own
 * "RSMC Subscriber Sign Up" title and description.
 *
 * @returns {JSX.Element} Subscribe page
 */
function Subscribe() {
  const location = useLocation();
  /** @type {{ email?: string } | null} */
  const state = location.state;
  const email = state?.email ?? '';

  return (
    <FormPageLayout
      title="Subscribe"
      subtitle="News, offerings and events from Ready Secure Managed Cloud"
      formFilePath="/forms/subscribe-form.txt"
      prefill={email ? { email } : undefined}
      errorMessage="Unable to load subscribe form"
      loadingMessage="Loading subscribe form..."
    />
  );
}

export default Subscribe;
